export const PROJECT_PICKER_MAX_PROJECT_LENGTH = 5;
